import React, { Component } from 'react';
import Image from 'react-bootstrap/Image'
import {
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { MenuItem, Nav, NavDropdown } from "react-bootstrap";
import AddEmployeeModal from './AddEmployeeModal';
import { Modal, Button } from "react-bootstrap";

export class UserLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: this.props.msalContext.accounts.length > 0,
            user: this.props.msalContext.instance.getAllAccounts()[0],
            RoleID: this.props.RoleID,
            isModalOpen: false,
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        console.log(this.props);
    }

    showModal(id) {
        console.log(id);
        this.setState({ isModalOpen: true });
        this.state.empIDForEdit = id;
    }

    hideModal() {
        this.setState({ isModalOpen: false });
    }



    render() {
        const defaultPic = "data:image/svg+xml;base64,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";
        if (this.state.isAuthenticated) {
            console.log(this.props.auth);
            return (
               

                //<UncontrolledDropdown>

                //    <DropdownToggle nav caret>
                //        <div className="me-2">
                //            <Image
                //                src={defaultPic}
                //                roundedCircle
                //                className="profile"
                //                />
                //        </div>
                //        <div className="ms-5">
                //            {this.state.user.name}
                //        </div>
                //    </DropdownToggle>
                //    <DropdownMenu right>
                //        <h5 className="dropdown-item-text mb-0">{this.state.user.name}</h5>
                //        <p className="dropdown-item-text text-muted mb-0">{this.state.user.userName}</p>
                //        <DropdownItem divider />
                //        <DropdownItem onClick={this.props.onSignOut}>Sign Out</DropdownItem>
                //    </DropdownMenu>
                //</UncontrolledDropdown>
                <NavDropdown eventKey={1}
                    title={
                        <div className="pull-left">
                            <img className="thumbnail-image"
                                src={defaultPic}
                                alt={this.state.user.name}
                                className="profile"
                            /> &nbsp;
  
                        </div>
                    }
                    id="basic-nav-dropdown">

                    <NavDropdown.Item eventKey={1.1} onClick={() => this.showModal(this.props.UserID)}>  {this.state.user.name} {this.props.RoleID == 1 ? " (Global Admin)" : this.props.RoleID?.includes(2) ? " (Admin)" : this.props.RoleID == null ? " (Guest)" : " (User)"}</NavDropdown.Item>
                    <NavDropdown.Item divider="true" />
                    <NavDropdown.Item eventKey={1.3}>
                        <i className="fa fa-sign-out"></i> <span onClick={this.props.onSignOut} > Logout </span>
                    </NavDropdown.Item>
                    <React.Fragment>
                        <Modal className="wld-Modal-md" size="lg" show={this.state.isModalOpen} onHide={this.hideModal}>
                            <Modal.Body className="ModalContentBox">
                                <AddEmployeeModal employeeID={this.state.empIDForEdit} hideModal={this.hideModal} roleID={this.state.RoleID} Page="profile" />
                            </Modal.Body>
                        </Modal>
                    </React.Fragment>
                </NavDropdown>
                 
            );
        }
        else {
            return (<NavItem>
                <NavLink className="text-dark" onClick={this.props.onSignIn} href='#'>Sign in</NavLink>
            </NavItem>);
        }

      
    }
}